import { render } from "./p-text-area.vue?vue&type=template&id=5d6248c4&scoped=true"
import script from "./p-text-area.vue?vue&type=script&lang=js"
export * from "./p-text-area.vue?vue&type=script&lang=js"

import "./p-text-area.vue?vue&type=style&index=0&id=5d6248c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6248c4"]])

export default __exports__